module.exports = __webpack_public_path__ + "img/skd-offline-light.d06da5f7.svg";